export enum ToolId {
    FoldAngleTool = 'foldAngleTool',
    FaceOrderingTool = 'faceOrderingTool',
    OrbitTool = 'orbitTool',
    PanTool = 'panTool',
    DollyTool = 'dollyTool',
    GroundFaceSelectionTool = 'groundFaceSelectionTool',
    WindowTool = 'windowTool',
}
